import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {ToasterService as LuxToasterService } from '@lendux/lendux-commons/toolkit';

@Injectable({
    providedIn: 'root'
})
export class ToasterService {

    toastRef;

    constructor(private toastr: ToastrService, private luxToaster: LuxToasterService) { }

    success(message: string) {
        this.luxToaster.success(message);
    }

    error(message: string) {
        this.luxToaster.error(message);
    }

    info(message: string) {
        this.luxToaster.info(message);
    }

    warning(message: string) {
        this.luxToaster.warning(message);
    }

    connectionLost() {
        this.toastRef = this.toastr.error('Lost connection to the server', 'Error', { closeButton: false, extendedTimeOut: 0, timeOut: 0, tapToDismiss: false });
    }

    closeConnectionToastr() {
        if (this.toastRef && this.toastRef.toastId) {
            this.toastr.remove(this.toastRef.toastId);
        }
    }
}
